/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { connectionsUpdate } from "../../funcs/connectionsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.UpdateConnectionConnectionsConnectionIdPutRequest$inboundSchema,
};

export const tool$connectionsUpdate: ToolDefinition<typeof args> = {
  name: "connections-update",
  description: `Update Connection

Updates a connections metadata or mode. These changes will be seen after the next sync.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await connectionsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
